export default {
  title: 'Mit {{method}} bezahlen',
  hint: 'Tippe unten auf den Button und bestätige die Zahlung im {{method}}-Fenster.',
  confirming: 'Deine Zahlung wird bestätigt …',
  cancel: 'Zahlung abbrechen',
  unavailable: 'Diese Zahlungsart ist gerade nicht verfügbar. Wähle eine andere.',
  approval_timeout:
    'Wir haben keine Rückmeldung von {{method}} erhalten. Falls sich kein Fenster geöffnet hat, prüfe, ob Pop-ups erlaubt sind, und versuche es dann erneut oder wähle eine andere Zahlungsart.',
};
